/* tslint:disable */

declare var Object: any;
export interface ERPprojectInterface {
  "id"?: number;
}

export class ERPproject implements ERPprojectInterface {
  "id": number;
  constructor(data?: ERPprojectInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPproject`.
   */
  public static getModelName() {
    return "ERPproject";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPproject for dynamic purposes.
  **/
  public static factory(data: ERPprojectInterface): ERPproject{
    return new ERPproject(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPproject',
      plural: 'ERPprojects',
      path: 'ERPprojects',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPproject.ts